import { put, call } from 'redux-saga/effects';
import { loadConfigService } from '../../services/appServices';
import { getAuthConfig } from '../../utils/authConfig';
import * as types from '../actions';

export function* loadConfigSaga(params) {
  try {

    const res = yield call(loadConfigService, params); 

    res.data.data.auth = getAuthConfig(
      res.data.data.azure.tenantId,
      res.data.data.azure.clientId,
      res.data.data.azure.audience
    )

    delete res.data.data.azure

    yield put({ 
        type: types.PUBLIC_LOAD_CONFIG_SUCCESS, 
        ...res.data,
        initialized: true
    });

  } catch(error) {

    yield put({ 
      type: types.PUBLIC_LOAD_CONFIG_ERROR, 
      message: error.message,
      initialized: false
    });

  }
}